import { Link } from "react-router-dom";
import { absCents, formatMoney } from "@/domain/money";
import type { PeriodStanding } from "@/hooks/use_data";

function remainingLabel(view: PeriodStanding): string {
  if (view.remaining === null) return "No budgets set yet";
  if (view.isOver) return `${formatMoney(absCents(view.remaining), view.currency)} over budget · flooded`;
  return `${formatMoney(view.remaining, view.currency)} left`;
}
function FamilyGauge({ percent, over }: { percent: number; over: boolean }): React.JSX.Element {
  return <span aria-hidden="true" className="relative size-8 shrink-0 overflow-hidden rounded-full border border-line">
    <span className={`absolute inset-x-0 bottom-0 ${over ? "bg-over" : "bg-acc"}`}
      style={{ height: `${Math.min(100, Math.max(0, percent))}%` }} />
  </span>;
}
export function FamilyHomeLine({ name, view, members = 0 }: {
  name: string; view: PeriodStanding; members?: number;
}): React.JSX.Element {
  const percent = Math.round(view.ratio * 100);
  return <Link to="/family"
    className="flex min-h-[44px] w-full items-center gap-phi-n1 border-y border-line bg-bg-2 px-phi-1 py-phi-n1 text-phi-n1">
    <FamilyGauge percent={percent} over={view.isOver} />
    <span className="min-w-0 flex-1">
      <span>👪 <b>{name}</b> · <span className={view.isOver ? "fig tnum text-over" : "fig tnum"}>{remainingLabel(view)}</span></span>
      <span className="block text-tx-2">
        {view.remaining === null ? "Set a family budget" : `${percent}% used`} · shared by {members}
      </span>
    </span>
    <span aria-hidden="true" className="text-acc">›</span>
  </Link>;
}
